import React from 'react';
import { useCountdown } from '../../hooks/useCountdown';
export function Countdown() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    label: 'Hours',
    value: hours
  }, {
    label: 'Min',
    value: minutes
  }, {
    label: 'Sec',
    value: seconds
  }];
  return <div className="w-full" role="timer" aria-live="off" data-id="element-346" data-mp="2c4egshaofbbq">
      <p className="text-center text-sm font-bold uppercase tracking-wide text-danger" data-id="element-347" data-mp="2c70yh9ra777o">
        Promotional price ends in:
      </p>
      <div className="mt-2 flex items-center justify-center gap-2" data-id="element-348" data-mp="1jgimtkchrxin">
        {units.map((unit, i) => <React.Fragment key={unit.label} data-id="element-349" data-mp="1xgjnayouh2xl" data-mpi={i}>
            <div className="flex w-[72px] flex-col items-center rounded-xl bg-ink py-2 text-white" data-id="element-350" data-mp="1xhl7ptrr31rz">
              <span className="font-display text-3xl font-black tabular-nums leading-none" data-id="element-351" data-mp="1td55q3l9cei1">
                {String(unit.value).padStart(2, '0')}
              </span>
              <span className="mt-1 text-[10px] font-semibold uppercase tracking-wider text-white/60" data-id="element-352" data-mp="34udd8xr7aaqf">{unit.label}</span>
            </div>
            {i < units.length - 1 && <span className="font-display text-2xl font-black text-ink" data-id="element-353" data-mp="2h6qe72c4t0v9">:</span>}
          </React.Fragment>)}
      </div>
    </div>;
}